module.exports = __webpack_public_path__ + "static/media/RectangleDe.c14bdb96.png";